import type { ComponentProps } from "react";
import { EntryScreen } from "../../features/entry";

/** FS-01 입장·로딩(문 A /launch · 문 B /sso) — 페이지는 조립만 한다(CSG 4.2). 화면 본체는 features/entry */
export default function EntryPage(props: ComponentProps<typeof EntryScreen>) {
  return <EntryScreen {...props} />;
}
